/** Admin-only: simulate plan limits (localStorage). */

export type SimulatePlanId = "free" | "starter" | "author" | "pro";

const STORAGE_KEY = "bbg_test_as_user";

export function getSimulatePlan(): SimulatePlanId | null {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(STORAGE_KEY);
  if (raw === "free" || raw === "starter" || raw === "author" || raw === "pro") return raw;
  return null;
}

export function setSimulatePlan(plan: SimulatePlanId | null): void {
  if (typeof window === "undefined") return;
  if (!plan) localStorage.removeItem(STORAGE_KEY);
  else localStorage.setItem(STORAGE_KEY, plan);
}

export function isSimulatingRegularUser(): boolean {
  return getSimulatePlan() !== null;
}
